export const GET_SHIPMENT_STATUS_REQUEST = 'GET_SHIPMENT_STATUS_REQUEST';
export const GET_SHIPMENT_STATUS_DATA = 'GET_SHIPMENT_STATUS_DATA';
export const GET_SHIPMENT_STATUS_ERROR = 'GET_SHIPMENT_STATUS_ERROR';

export const SET_SHIPMENT_SORT_DATA = 'SET_SHIPMENT_SORT_DATA';
export const SORTING_SHIPMENT_ACTION = 'SORTING_SHIPMENT_ACTION';

export const CREATE_SHIPMENT_STATUS_REQUEST = 'CREATE_SHIPMENT_STATUS_REQUEST';
export const CREATE_SHIPMENT_STATUS_DATA = 'CREATE_SHIPMENT_STATUS_DATA';
export const CREATE_SHIPMENT_STATUS_ERROR = 'CREATE_SHIPMENT_STATUS_ERROR';

export const UPDATE_SHIPMENT_STATUS_REQUEST = 'UPDATE_SHIPMENT_STATUS_REQUEST';
export const UPDATE_SHIPMENT_STATUS_DATA = 'UPDATE_SHIPMENT_STATUS_DATA';
export const UPDATE_SHIPMENT_STATUS_ERROR = 'UPDATE_SHIPMENT_STATUS_ERROR';

export const DELETE_SHIPMENT_STATUS_REQUEST = 'DELETE_SHIPMENT_STATUS_REQUEST';
export const DELETE_SHIPMENT_STATUS_DATA = 'DELETE_SHIPMENT_STATUS_DATA';
export const DELETE_SHIPMENT_STATUS_ERROR = 'DELETE_SHIPMENT_STATUS_ERROR';
